import { types as sdkTypes } from './util/sdkLoader';

const { LatLng, LatLngBounds } = sdkTypes;

// An array of locations to show in the LocationAutocompleteInput when
// the input is in focus but the user hasn't typed in any search yet.
//
// Each item in the array should be an object with a unique `id` (String) and a
// `predictionPlace` (util.types.place) properties.
export default [
  // {
  //   id: 'default-paris',
  //   predictionPlace: {
  //     address: 'Paris, France',
  //     origin: new LatLng(48.856614, 2.3522219),
  //     bounds: new LatLngBounds(new LatLng(48.90214747577797, 2.469850925555473), new LatLng(48.81556220872687, 2.224219054341255)),
  //     city: 'Paris',
  //   },
  // },
  // {
  //   id: 'default-lyon',
  //   predictionPlace: {
  //     address: 'Lyon, France',
  //     origin: new LatLng(45.764043, 4.835659),
  //     bounds: new LatLngBounds(new LatLng(45.80842023024812, 4.89839565734974), new LatLng(45.70748123957289, 4.771864514505881)),
  //     city: 'Lyon',
  //   },
  // },
  // {
  //   id: 'default-marseille',
  //   predictionPlace: {
  //     address: 'Marseille, France',
  //     origin: new LatLng(43.296482, 5.36978),
  //     bounds: new LatLngBounds(new LatLng(43.39105653360466, 5.532543303418947), new LatLng(43.16963412607587, 5.228753442219432)),
  //     city: 'Marseille',
  //   },
  // },
  // {
  //   id: 'default-montpellier',
  //   predictionPlace: {
  //     address: 'Montpellier, France',
  //     origin: new LatLng(43.610769, 3.876716),
  //     bounds: new LatLngBounds(new LatLng(43.65329457274589, 3.941286923984968), new LatLng(43.56673777231237, 3.807051777238071)),
  //     city: 'Montpellier',
  //   },
  // },
  // {
  //   id: 'default-nice',
  //   predictionPlace: {
  //     address: 'Nice, France',
  //     origin: new LatLng(43.7101728, 7.261953200000001),
  //     bounds: new LatLngBounds(new LatLng(43.76090955142507, 7.323476132114018), new LatLng(43.64548087811181, 7.182147752528378)),
  //     city: 'Nice',
  //   },
  // },
  // {
  //   id: 'default-toulouse',
  //   predictionPlace: {
  //     address: 'Toulouse, France',
  //     origin: new LatLng(43.604652, 1.444209),
  //     bounds: new LatLngBounds(new LatLng(43.66871355576912, 1.515355784543877), new LatLng(43.53269286358267, 1.350329140450176)),
  //     city: 'Toulouse',
  //   },
  // },
  // {
  //   id: 'default-bordeaux',
  //   predictionPlace: {
  //     address: 'Bordeaux, France',
  //     origin: new LatLng(44.837789, -0.57918),
  //     bounds: new LatLngBounds(new LatLng(44.91669416098772, -0.5333254042171431), new LatLng(44.81074136006902, -0.6386987495789168)),
  //     city: 'Bordeaux',
  //   },
  // },
  // {
  //   id: 'default-avignon',
  //   predictionPlace: {
  //     address: 'Avignon, France',
  //     origin: new LatLng(43.94931700000001, 4.805528),
  //     bounds: new LatLngBounds(new LatLng(43.99663973008948, 4.927231274986552), new LatLng(43.88647227505248, 4.739283428670957)),
  //     city: 'Avignon',
  //   },
  // },
  // {
  //   id: 'default-nimes',
  //   predictionPlace: {
  //     address: 'Nîmes, France',
  //     origin: new LatLng(43.836699, 4.360054),
  //     bounds: new LatLngBounds(new LatLng(43.92287523828904, 4.449922304658408), new LatLng(43.7414352535374, 4.23579492801604)),
  //     city: 'Nîmes',
  //   },
  // },
];
